import Axios from 'axios';
import { getAuthHeader } from './authToken';

const BASE = `${process.env.REACT_APP_URL}/api/v2`;

const headers = () => ({
    'Content-Type': 'application/json',
    'Authorization': getAuthHeader(),
});

const api = {
    get: (path, params) => Axios.get(`${BASE}${path}`, { headers: headers(), params }),
    post: (path, data) => Axios.post(`${BASE}${path}`, data, { headers: headers() }),
    put: (path, data) => Axios.put(`${BASE}${path}`, data, { headers: headers() }),
    patch: (path, data) => Axios.patch(`${BASE}${path}`, data, { headers: headers() }),
    delete: (path, params) => Axios.delete(`${BASE}${path}`, { headers: headers(), params }),
    // For multipart uploads (test PDF, rubric files)
    upload: (path, formData) => Axios.post(`${BASE}${path}`, formData, {
        headers: { 'Authorization': getAuthHeader() },
    }),
    uploadPut: (path, formData) => Axios.put(`${BASE}${path}`, formData, {
        headers: { 'Authorization': getAuthHeader() },
    }),
    uploadWithProgress: (path, formData, onProgress) => Axios.post(`${BASE}${path}`, formData, {
        headers: { 'Authorization': getAuthHeader() },
        onUploadProgress: (e) => onProgress?.(Math.round((e.loaded * 100) / e.total)),
    }),
};

export default api;
